import React, { useState } from 'react';

const CancellationPolicyAgreement = () => {

  return (
    <div className="max-w-xl mx-auto p-6 rounded-xl pt-8">
      <h2 className="text-xl font-semibold mb-3">Cancellation</h2>
      <ul className="list-disc pl-6 mb-6 text-sm space-y-2">
        <li><strong>Non-refundable: </strong>25% of the total</li>

      </ul>

    </div>
  );
};

export default CancellationPolicyAgreement;